export const setHotjarEmail = (email) => {
  if (!email || !window.hj) return;

  window.hj("identify", email, { email: email });
};
